import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KeyboardComponent } from './keyboard.component';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  declarations: [KeyboardComponent],
  exports: [KeyboardComponent],
  imports: [CommonModule, FlexLayoutModule],
  providers: [KeyboardComponent],
})
export class KeyboardModule {}
